module.exports = __webpack_public_path__ + "src/assets/img/sultan-selector-plane.c60a6eb7.png";